import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


import './index.css';
// import Bootstrap
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import '../node_modules/bootstrap/dist/css/bootstrap-theme.css';

ReactDOM.render(<App />,document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js